import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// 🔒 PHASE 2: ProtectedRoute mit Schutz gegen Hänger
const ProtectedRoute = ({ children, allowGuest = false }) => {
  const { user, isLoading, isAuthenticated } = useAuth();

  // DEBUG LOGS - CRITICAL DEBUGGING
  useEffect(() => {
    console.log('DEBUG ProtectedRoute RENDER:', {
      user: !!user,
      isLoading,
      isAuthenticated,
      userEmail: user?.email || 'null'
    });
  }, [user, isLoading, isAuthenticated]);

  console.log('DEBUG ProtectedRoute: Rendering with state:', { 
    isLoading, 
    isAuthenticated, 
    user: !!user 
  });

  // 🔧 PHASE 2: Sichere Loading-State Behandlung
  if (isLoading) {
    console.log('DEBUG ProtectedRoute: Showing loading state');
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Lade Session...</p>
          <p className="text-xs text-gray-400 mt-2">Max. 8 Sekunden</p>
        </div>
      </div>
    );
  }

  // 🔧 PHASE 2: Sichere Redirect-Logic
  if (!isAuthenticated && !allowGuest) {
    console.log('DEBUG ProtectedRoute: Redirecting to login - user not authenticated');
    return <Navigate to="/login" replace />;
  }

  // 🔧 PHASE 2: Sichere Content-Rendering
  console.log('DEBUG ProtectedRoute: Rendering protected content');
  return children;
};

export default ProtectedRoute;

